const stats = [
  { value: "4", label: "种内容形式" },
  { value: "42", label: "条目录条目" },
  { value: "12", label: "章 / 集最新进度" },
  { value: "持续", label: "整理更新" },
];

export default function Hero() {
  return (
    <section id="top" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto grid w-full items-center gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-2 lg:gap-14">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1 text-xs font-medium tracking-wide text-accent-700">
            <i className="ri-bookmark-3-line" />
            一份给追更观众的整理笔记
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
            善良的嫂子
            <span className="mt-2 block text-lg font-semibold text-foreground-700 md:text-2xl">
              小说、短剧、漫画、视频 · 全集资源一站导航
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            围绕《善良的嫂子》这一作品，本页把小说章节、短剧剧集、漫画话数与视频资源集中整理到一处。
            无论你想看原著文字、刷竖屏短剧，还是用漫画与解说回顾剧情，都能在这里按顺序找到入口，不必再四处翻找。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#library"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-list-check-2" />
              进入内容目录
            </a>
            <a
              href="#guide"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-compass-3-line" />
              查看追更指南
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-4 border-t border-background-200 pt-6 sm:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-2xl font-bold text-primary-700">{item.value}</dt>
                <dd className="mt-1 text-xs text-foreground-500">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative">
          <div className="relative h-[280px] w-full overflow-hidden rounded-lg border border-background-200 sm:h-[380px] lg:h-[460px]">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20toned%20painterly%20illustration%20of%20a%20quiet%20Chinese%20rural%20courtyard%20at%20early%20morning%2C%20wooden%20eaves%20and%20soft%20lanterns%2C%20steam%20rising%20from%20a%20kettle%2C%20golden%20amber%20tones%2C%20gentle%20nostalgic%20atmosphere%2C%20textured%20brush%20strokes%2C%20no%20text&width=900&height=1100&seq=hero-courtyard-01&orientation=portrait"
              alt="清晨的农家小院：木屋檐、暖色灯火与升腾的热气，营造温暖怀旧的氛围"
              className="h-full w-full object-top"
            />
          </div>
          <div className="mt-4 flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-information-line" />
            </span>
            <p className="text-xs leading-relaxed text-foreground-600 md:text-sm">
              本页内容为作品相关信息的整理与导航，条目按作品顺序排列，方便按需浏览与追更。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}